import React from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'
import LinkPopup from './LinkPopup'
import { HashLink } from 'react-router-hash-link'
import PrivacyPolicy from '../legal/PrivacyPolicy'
import TermsOfUse from '../legal/TermsOfUse'
import appStoreIcon from '../../images/icon-app-store.png'
import googlePlayIcon from '../../images/icon-google-play.png'
import logo from '../../images/footer-logo.png'

const scrollToTop = event => {
  event.preventDefault()
  animateScroll.scrollToTop()
}
const FOODSBY_BASE_URL = process.env.REACT_APP_FOODSBY_BASE_URL

const Footer = ({
  showLogo,
  isAuthenticated,
  showMobileBadges = 'true',
  currentUser
}) => (
  <footer className="footer">
    {showLogo ? (
      <div className="footer-logo">
        <a href={`${FOODSBY_BASE_URL}`}>
          <img src={logo} alt="Order with Foodsby" className="logo" />
        </a>
      </div>
    ) : null}
    <div className="footer-wrapper">
      <nav className="footer-nav">
        <ul>
          <li>
            <a
              href={
                isAuthenticated
                  ? `/contact`
                  : `${FOODSBY_BASE_URL}/main/contact/`
              }
            >
              Contact
            </a>
          </li>
          {!currentUser && (
            <li>
              <a href={`${FOODSBY_BASE_URL}/main/restaurants-login/`}>
                Restaurant Login
              </a>
            </li>
          )}
          <li>
            <LinkPopup linkText="Terms of Use">
              <TermsOfUse />
            </LinkPopup>
          </li>
          <li>
            <LinkPopup linkText="Privacy Policy">
              <PrivacyPolicy />
            </LinkPopup>
          </li>
          <li>
            <HashLink to="/privacy#ad-choices">Ad Choices</HashLink>
          </li>
          <li>
            <a
              href={`${FOODSBY_BASE_URL}/main/careers`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Careers
            </a>
          </li>
        </ul>
      </nav>
      <button
        onClick={scrollToTop}
        className="link footer-up"
        title="scroll to top"
      >
        <i className="icon icon-angle-up" />
      </button>
      {showMobileBadges ? (
        <div>
          <div>
            <a
              href="https://itunes.apple.com/us/app/foodsby/id875062433?mt=8"
              className="app-icon"
            >
              <img
                height="42"
                width="140"
                src={appStoreIcon}
                alt="Get the Foodsby app on the App Store"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.foodsby.consumerApp&amp;hl=en"
              className="app-icon"
            >
              <img
                height="42"
                width="140"
                src={googlePlayIcon}
                alt="Get the Foodsby app on Google Play"
              />
            </a>
          </div>
        </div>
      ) : null}
    </div>
  </footer>
)

function mapStateToProps(state) {
  const { currentUser } = state.user
  return {
    currentUser
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer)
